"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MessageMediaAttachment;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));

var _Refresh = _interopRequireDefault(require("@material-ui/icons/Refresh"));

var _CameraAlt = _interopRequireDefault(require("@material-ui/icons/CameraAlt"));

var _PlayCircleFilled = _interopRequireDefault(require("@material-ui/icons/PlayCircleFilled"));

var _constants = require("./constants");

var _Close = _interopRequireDefault(require("../../theme/icons/Close"));

var _Lock = _interopRequireDefault(require("../../theme/icons/Lock"));

var _Button = _interopRequireDefault(require("../Button"));

var _Video = _interopRequireDefault(require("../Video"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _MessageEditor = require("../MessageEditor");

var _styled = require("./styled");

var getAttachmentThumbnailForType = function getAttachmentThumbnailForType(attachmentType, thumbnail, src, onToggleDialog) {
  switch (attachmentType) {
    case _MessageEditor.MESSAGE_MEDIA_TYPES.LINK:
      return /*#__PURE__*/_react["default"].createElement(_Link["default"], null);

    case _MessageEditor.MESSAGE_MEDIA_TYPES.IMAGE:
      {
        if (!thumbnail) {
          return /*#__PURE__*/_react["default"].createElement(_CameraAlt["default"], null);
        }

        return /*#__PURE__*/_react["default"].createElement(_styled.Image, {
          src: thumbnail,
          onClick: src ? onToggleDialog : undefined,
          width: 24,
          height: 24
        });
      }

    case _MessageEditor.MESSAGE_MEDIA_TYPES.VIDEO:
      {
        if (!thumbnail) {
          return /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], null);
        }

        return /*#__PURE__*/_react["default"].createElement(_styled.Image, {
          src: thumbnail,
          onClick: src ? onToggleDialog : undefined,
          width: 24,
          height: 24
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          container: true,
          alignItems: "center",
          justify: "center"
        }, /*#__PURE__*/_react["default"].createElement(_styled.PlayIcon, null)));
      }

    case _MessageEditor.MESSAGE_MEDIA_TYPES.PDF:
      {
        return /*#__PURE__*/_react["default"].createElement(_styled.PdfIcon, null);
      }

    default:
      return /*#__PURE__*/_react["default"].createElement(_styled.AttachmentIcon, null);
  }
};

var getStatus = function getStatus(isUploading, uploadProgress, uploadingText, isError, errorText, onRefresh, refreshText, id) {
  if (isUploading) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      container: true,
      spacing: 2,
      alignItems: "center",
      justify: "flex-end",
      wrap: "nowrap"
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true
    }, uploadProgress === null || uploadProgress === undefined ? /*#__PURE__*/_react["default"].createElement(_Loading["default"], {
      size: 20
    }) : /*#__PURE__*/_react["default"].createElement(_styled.LinearProgress, {
      variant: "determinate",
      value: uploadProgress
    })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      disableOverflowWrap: true
    }, uploadProgress === null || uploadProgress === undefined ? uploadingText : "".concat(uploadProgress, "%"))));
  }

  if (isError) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      alignItems: "center",
      spacing: 1,
      justify: "flex-end",
      wrap: "nowrap"
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_styled.ErrorTypography, {
      disableOverflowWrap: true
    }, errorText)), onRefresh && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: "".concat(id, "-refresh-button"),
      flat: true,
      icon: true,
      size: "xsmall",
      onClick: onRefresh
    }, /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null), refreshText)));
  }

  return null;
};

function MessageMediaAttachment(_ref) {
  var id = _ref.id,
      type = _ref.type,
      name = _ref.name,
      thumbnail = _ref.thumbnail,
      subheading = _ref.subheading,
      onDelete = _ref.onDelete,
      isUploading = _ref.isUploading,
      uploadProgress = _ref.uploadProgress,
      uploadingText = _ref.uploadingText,
      isError = _ref.isError,
      errorText = _ref.errorText,
      refreshText = _ref.refreshText,
      onRefresh = _ref.onRefresh,
      src = _ref.src,
      closeText = _ref.closeText,
      poster = _ref.poster,
      isDialogOpen = _ref.isDialogOpen,
      onToggleDialog = _ref.onToggleDialog,
      disableDelete = _ref.disableDelete,
      size = _ref.size;
  var status = getStatus(isUploading, uploadProgress, uploadingText, isError, errorText, onRefresh, refreshText, id);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styled.ContainerBox, {
    padding: size === _constants.MESSAGE_MEDIA_ATTACHMENT_SIZE.SMALL ? 0.5 : 1.5,
    flex: 1,
    minWidth: 0
  }, /*#__PURE__*/_react["default"].createElement(_styled.ContainerGrid, {
    container: true,
    alignItems: "center",
    justify: "center",
    wrap: "nowrap",
    spacing: size === _constants.MESSAGE_MEDIA_ATTACHMENT_SIZE.SMALL ? 1 : 3,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_styled.IconWrapper, {
    container: true,
    justify: "center",
    alignItems: "center"
  }, getAttachmentThumbnailForType(type, thumbnail, src, onToggleDialog))), /*#__PURE__*/_react["default"].createElement(_styled.TextWrapper, {
    container: true,
    item: true,
    zeroMinWidth: true,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    container: true,
    zeroMinWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    noWrap: true,
    variant: size === _constants.MESSAGE_MEDIA_ATTACHMENT_SIZE.SMALL ? 'body2' : 'body1'
  }, name)), subheading && /*#__PURE__*/_react["default"].createElement(_styled.SubheadingWrapper, {
    item: true,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    noWrap: true,
    color: "inherit"
  }, subheading))), status && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, status), !disableDelete && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, onDelete ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "".concat(id, "-delete-button"),
    icon: true,
    flat: true,
    licorice: true,
    size: "xsmall",
    disablePadding: size === _constants.MESSAGE_MEDIA_ATTACHMENT_SIZE.SMALL,
    onClick: onDelete
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Lock["default"], null))))), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isDialogOpen,
    onClose: onToggleDialog,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    justify: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "".concat(id, "-close-dialog-button-top"),
    onClick: onToggleDialog,
    icon: true,
    flat: true,
    licorice: true
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)))), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    justify: "center",
    alignItems: "center"
  }, type === _MessageEditor.MESSAGE_MEDIA_TYPES.IMAGE && /*#__PURE__*/_react["default"].createElement(_styled.HTMLImg, {
    src: src,
    alt: "lightbox"
  }), type === _MessageEditor.MESSAGE_MEDIA_TYPES.VIDEO && src && /*#__PURE__*/_react["default"].createElement(_Video["default"], {
    poster: poster,
    src: src
  }))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "".concat(id, "-close-dialog-button-bottom"),
    onClick: onToggleDialog,
    ghost: true,
    licorice: true
  }, closeText))));
}

MessageMediaAttachment.defaultProps = {
  onDelete: undefined,
  thumbnail: undefined,
  uploadProgress: undefined,
  isUploading: false,
  isError: false,
  errorText: '',
  refreshText: '',
  uploadingText: '',
  onRefresh: undefined,
  src: undefined,
  poster: undefined,
  isDialogOpen: false,
  onToggleDialog: undefined,
  closeText: '',
  type: undefined,
  disableDelete: false,
  subheading: undefined,
  size: _constants.MESSAGE_MEDIA_ATTACHMENT_SIZE.MEDIUM
};